import { gql, useMutation, MutationHookOptions } from '@apollo/client';
import {
  updateCurrentUserMutation,
  updateCurrentUserMutationVariables,
  currentUserQuery
} from '../../core-types';
import { CURRENT_USER_FRAGMENT } from './fragments/currentUser';
import { CURRENT_USER_QUERY } from './useCurrentUser';

export const UPDATE_CURRENT_USER = gql`
  ${CURRENT_USER_FRAGMENT}
  mutation updateCurrentUserMutation($input: UserInput) {
    updateCurrentUser(input: $input) {
      __typename
      ...CurrentUser
    }
  }
`;

export const useUpdateCurrentUserMutation = (
  options?: Omit<
    MutationHookOptions<
      updateCurrentUserMutation,
      updateCurrentUserMutationVariables
    >,
    'update'
  >
) =>
  useMutation<updateCurrentUserMutation, updateCurrentUserMutationVariables>(
    UPDATE_CURRENT_USER,
    {
      ...options,
      update: (cache, { data }) => {
        if (!data) {
          return;
        }
        const { updateCurrentUser } = data;
        const currentUserResult = cache.readQuery<currentUserQuery>({
          query: CURRENT_USER_QUERY
        });
        if (!currentUserResult) {
          return;
        }
        cache.writeQuery<currentUserQuery>({
          query: CURRENT_USER_QUERY,
          data: {
            ...currentUserResult,
            currentUser: currentUserResult.currentUser
              ? {
                  ...currentUserResult.currentUser,
                  ...updateCurrentUser
                }
              : updateCurrentUser
          }
        });
      }
    }
  );
